import { BinWithChildren } from '../../utils/createBinTree'

type BinOutlineProps = {
  bins: BinWithChildren[]
  onClick: (id: string) => void
}

export const BinOutline: (props: BinOutlineProps) => JSX.Element = (props: BinOutlineProps): JSX.Element => {
  if (props.bins.length === 0) return <></>
  return (
    <ul>
      {props.bins.map((bin) => (
        <li key={bin.id}>
          <span
            style={{
              textDecoration: 'underline',
              color: 'blue',
              cursor: 'pointer',
            }}
            onClick={() => props.onClick(bin.id)}
          >
            {bin.name}
            <span style={{ fontStyle: 'italic' }}> (id: {bin.id})</span>
            {bin.description && ` - ${bin.description}`}
          </span>
          <BinOutline bins={bin.children ?? []} onClick={props.onClick} />
        </li>
      ))}
    </ul>
  )
}
